import script from "./ImportIEPModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportIEPModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImportIEPModal.vue?vue&type=style&index=0&id=d1cfbc9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1cfbc9e"]])

export default __exports__